import React, { useEffect, useState } from 'react';
import { Page, Dashboard } from '../../templates';
import { Typography, FlexBox } from '../../atoms';
import palette from '../../../utils/colorPalette';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { ReactDataTable, Accordion } from '../../molecules';
import { ValueFormatter } from '../../../utils/valueFormatter';


const PLMOrder = () => {
  const { id } = useParams();     
  const [table, setTable] = useState({});
  const [alertShown, setAlertShown] = useState(false); // 알림 상태 추가
  const [currentTab, clickTab] = useState(0);
  const [mainColumns, setMainColumns] = useState(     
      {ttl: [],
      kor: [],
      chn: [],
      gvl: [],
    });
    useEffect(() => {
      fetch(`/api/plm-order-data/${id}`)
        .then((res) => res.json())
        .then((res) => {
          if (res.detail_ttl.length === 0) {
            if (!alertShown) {
              setAlertShown(true);
            }
          } else {
          setTable(res);
      }
        })
        .catch((err) => {
          console.error('Error fetching order data:', err);
        });
    }, [id]); 

    useEffect(() => {
      if (alertShown) {
            alert('발주 데이터가 없습니다.'); 
            window.close();
      }
    }, [alertShown]);

  const selectMenuHandler = (index) => {
      clickTab(index);
}; 

  const menuList = [{ id: 'ttl', name: '전체', content: <ReactDataTable rows={table.ttl} columns={mainColumns.ttl} highlightFields={ ['', '비중', '합계', '한국', '중국', '글로벌']} boldFields={['']}/> },
        { id: 'kor', name: '한국', content: <ReactDataTable rows={table.kor} columns={mainColumns.kor} highlightFields={ ['', '비중', '합계']} boldFields={['']}/> },
        { id: 'chn', name: '중국', content: <ReactDataTable rows={table.chn} columns={mainColumns.chn} highlightFields={ ['', '비중', '합계']} boldFields={['']}/> },
        { id: 'gvl', name: '글로벌', content: <ReactDataTable rows={table.gvl} columns={mainColumns.gvl} highlightFields={ ['', '비중', '합계']} boldFields={['']}/> },
      ];

      useEffect(() => {
            // 열 정의 생성 함수
            const generateColumns = (data) => {
              if (data && data.length > 0) {
                const columns = Object.entries(data[0])
                  .map(([key]) => ({
                    field: key,
                    label: key,
                    width: '90px',
                    valueFormatter: (params) => params.value === 'NaN%' ? '-' : params.value,
                  }));
          
                // '' 열을 맨 앞에 위치하도록 정렬
                const emptyColumnIndex = columns.findIndex((col) => col.field === '');
                if (emptyColumnIndex !== -1) {
                  const [emptyColumn] = columns.splice(emptyColumnIndex, 1); // '' 열 추출
                  columns.unshift(emptyColumn); // 맨 앞에 삽입
                }
          
                return columns;
              }
              return [];
            };
          
            // 각 테이블 데이터에 대해 열 정의를 생성하여 상태 업데이트
            setMainColumns({
              ttl: generateColumns(table.ttl),
              kor: generateColumns(table.kor),
              chn: generateColumns(table.chn),
              gvl: generateColumns(table.gvl),
            });
          }, [table]);
          
  return (
    <Page style={{background: 'white'}}>
      <Dashboard style={{ width: '90%', padding: '5% 50px'}}>
            <Typography
              variant="header1"
              style={{ color: palette.text.default, alignSelf: 'flex-start', fontSize: '1.75rem' }}
            >
              {id} 발주현황
            </Typography>
            <div
      style={{
        height: 'auto',
        overflow: 'hidden',
        alignSelf: 'flex-start',
        marginTop: '30px',
      }}
    >
      <TabMenu>
        {menuList.map((el, index) => {
          if (typeof el.content === 'string' || el.content instanceof String) {
            return (
              <FlexBox
                style={{
                  background: `#E6E4E4`,
                  padding: '6px 8px',
                  marginBottom: '12px',
                  borderRadius: '1rem',
                  marginRight: '5px',
                }}
              >
                <Typography variant="content2">{el.content}</Typography>
              </FlexBox>
            );
          } else {
            return (
              <li
                className={index === currentTab ? 'submenu focused' : 'submenu'}
                key={index}
                onClick={() => selectMenuHandler(index)}
                style={{ fontSize: '0.8rem' }}
              >
                {el.name}
              </li>
            );
          }
        })}
      </TabMenu>
      {menuList[currentTab].content}
    </div>
    <Accordion
                style={{ marginTop: '30px', alignSelf: 'flex-start' }}
                headerStyle={{ background: 'white', justifyContent: 'left', width: 'fit-content' }}
                title={
                  <div style={{ marginLeft: '30px' }}>상세정보</div>
                }
                height="270px"
                hover="blue"
                children={
                  <div>
                  {table[`detail_${menuList[currentTab].id}`] && table[`detail_${menuList[currentTab].id}`].length > 0 ? (
                    <ReactDataTable
                      columns={detailColumns}
                      rows={table[`detail_${menuList[currentTab].id}`]}
                    />
                  ) : (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#999', fontSize: '14px' }}>
                      데이터가 없습니다.
                    </div>
                  )}
                  </div>
                }
              ></Accordion>
      </Dashboard>    
    </Page>
  );
};


export default PLMOrder;

const detailColumns = [
      { field: 'PO번호', label: 'PO번호', width: '180px' },
      { field: '발주수량', label: '발주수량', width: '100px', valueFormatter: (params) => ValueFormatter(params.value, 'currency') },
      {
        field: '입고요청일',
        label: '입고요청일',
        width: '130px',
        align: 'right',

      }, 
      { field: 'po국가', label: 'PO국가', width: '100px' }, 
      { field: '협력사', label: '협력사', width: '250px' },];


const TabMenu = styled.ul`
  //color: #777777;
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style: none;
  margin-top: 10px;
  height: 30px;
  margin-bottom: 2px;
  padding: 0;

  .submenu {
    font-family: NotoSansKR-Regular;
    display: flex;
    justify-content: center;
    height: 20px;
    width: auto;
    min-width: 45px;
    padding: 10px;
    font-size: 0.75rem;
    //transition: 0.2s;
    border-radius: 5px 5px 0px 0px;
    cursor: pointer;
  }

  .focused {
    //선택된 Tabmenu 에만 적용되는 CSS를 구현
    border: 1px solid #dee2e6;
    border-bottom: none;
  }

  & div.desc {
    text-align: center;
  }
  
  .submenu:hover {
    color: #0d6efd;
    }
`;